import { useSelector as selector, useDispatch as dispatch } from 'react-redux';

export const useSelector = selector;
export const useDispatch = () => dispatch();
